import { Text } from '@chakra-ui/react';

import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../sections/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IProps {
  title: string;
  warning: string;
  historyStatus: SectionStatus;
  consentsStatus: SectionStatus;
  financeStatus: SectionStatus;
}

type Props = IProps;

const PersonalQPage1 = (props: Props) => {
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section1={SectionStatus.todo}
      section2={props.historyStatus}
      section3={props.consentsStatus}
      section4={props.financeStatus}
      section={props.title}
      minsToComplete={10}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Text dangerouslySetInnerHTML={{ __html: props.warning }} />
    </SectionStartTemplate>
  );
};

export default PersonalQPage1;
